// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimsTeamSaveContactDto
 */
export interface IClaimsTeamSaveContactDto {
    /**
     * 
     * @type {Set<number>}
     * @memberof IClaimsTeamSaveContactDto
     */
    contacts_ids?: Set<number>;
}

/**
 * Check if a given object implements the IClaimsTeamSaveContactDto interface.
 */
export function instanceOfIClaimsTeamSaveContactDto(value: object): value is IClaimsTeamSaveContactDto {
    return true;
}

export function IClaimsTeamSaveContactDtoFromJSON(json: any): IClaimsTeamSaveContactDto {
    return IClaimsTeamSaveContactDtoFromJSONTyped(json, false);
}

export function IClaimsTeamSaveContactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimsTeamSaveContactDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contacts_ids': json['contacts_ids'] == null ? undefined : new Set(json['contacts_ids']),
    };
}

export function IClaimsTeamSaveContactDtoToJSON(json: any): IClaimsTeamSaveContactDto {
    return IClaimsTeamSaveContactDtoToJSONTyped(json, false);
}

export function IClaimsTeamSaveContactDtoToJSONTyped(value?: IClaimsTeamSaveContactDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contacts_ids': value['contacts_ids'] == null ? undefined : Array.from(value['contacts_ids'] as Set<any>),
    };
}

